/**
 * Maps customer subdomain slugs to Auth0 connection names.
 * Slugs must match normalized values from getCustomerSlugFromHostname.
 */
export const TENANT_CONNECTIONS: Record<string, string> = {
  acme: 'acme-saml'
};

export const getConnectionForTenant = (slug: string): string | null =>
  TENANT_CONNECTIONS[slug] ?? null;
